<template>
  <div class="container hasMenu">
    <div class="cmTitle flexBw" v-if="isLoaded">
      <h4>
        我创建的班级<span v-if="!myClsList.length && isLoaded">还没有班级哦，快来创建一个班级吧～</span>
      </h4>
      <div class="clBtn flex-center" @click="$refs.classRef.openClassInfo()" v-if="isPage && myClsList.length">
        <span class="iconfont chuangjian"></span> 创建班级
      </div>
    </div>
    <ul class="flex">
      <li v-for="item in myClsList" :key="item.id" @click.stop="$emit('onDetail', item.id)">
        <div class="flexBw clHead">
          <div class="line1">{{ item.school }}</div>
          <span class="clSign" :class="item.authStatus">{{
            item.authStatusTxt
          }}</span>
        </div>
        <div class="clInfos flexBw">
          <div class="clLeft">
            <img src="https://llss-file.langsounds.com/app/956dc1975353a8974aa74976f82b0ef6.png" />
            <span class="clSign" v-if="!item.isJoin">管理员</span>
          </div>
          <div class="clRight flex-1">
            <div class="grade">
              {{ item.gradeTxt }}
            </div>
            <div class="clDish" v-if="isPage && !item.isJoin" @click.stop>
              <img src="https://llss-file.langsounds.com/picture/5884f964dad7833a7fec15bf76e50129.png" class="clMore" />
              <div class="clMenus">
                <p class="flex-center" @click.stop="$refs.classRef.openClassInfo(item.id)">
                  班级设置
                </p>
                <p class="flex-center" @click.stop="$emit('onCode', item.id)">
                  邀请学生
                </p>
                <p class="flex-center" @click.stop="delClassObj = { ...item, status: true }">
                  解散班级
                </p>
              </div>
            </div>
            <div class="clTeach flex">
              <div class="line1">{{ item.classesAdmin }}</div>
              <span class="iconfont denglurenxiang"></span>
              <p class="clPerson flex-center">
                <span class="clNum">{{ item.studentCnt }}</span> 人
              </p>
            </div>
            <div class="invite">
              学生邀请码：<span>{{ item.invitationCode }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <template v-if="!myClsList.length && isLoaded">
      <div class="flex-center flex-v space" @click="$refs.classRef.openClassInfo()" v-if="isPage">
        <span class="iconfont chuangjian"></span>
        创建班级
      </div>
      <Empty v-else/>
    </template>
    <div class="cmTitle flexBw" v-if="isLoaded">
      <h4>
        我加入的班级<span v-if="!addClsList.length && isLoaded">还没有加入班级哦，快来加入一个班级吧～</span>
      </h4>
      <div class="clBtn flex-center" @click="openAddClass" v-if="isPage && addClsList.length">
        <span class="iconfont tianjia"></span> 加入班级
      </div>
    </div>
    <ul class="flex">
      <li v-for="item in addClsList" :key="item.id" @click.stop="changeStatus(item)">
        <div class="flexBw clHead">
          <div class="line1">{{ item.school }}</div>
          <div>
            <span class="clSign" :class="item.authStatus">{{
              item.authStatusTxt
            }}</span>
            <span class="clSign caSign" :class="item.classesAuditStatus === 3 ? 'AUTH_WAITING' : 'WAITING'
              " v-if="item.classesAuditStatus !== 2">{{ item.classesAuditStatusTxt }}</span>
          </div>
        </div>
        <div class="clInfos flexBw">
          <div class="clLeft">
            <img src="https://llss-file.langsounds.com/app/956dc1975353a8974aa74976f82b0ef6.png" />
            <span class="clSign" v-if="!item.isJoin">管理员</span>
          </div>
          <div class="clRight flex-1">
            <div class="grade">
              {{ item.gradeTxt }}
            </div>
            <div class="clDish" v-if="isPage && !item.isJoin" @click.stop>
              <img src="https://llss-file.langsounds.com/picture/5884f964dad7833a7fec15bf76e50129.png" class="clMore" />
              <div class="clMenus">
                <p class="flex-center" @click.stop="$refs.classRef.openClassInfo(item.id)">
                  班级设置
                </p>
                <p class="flex-center" @click.stop="$emit('onCode', item.id)">邀请学生</p>
                <p class="flex-center" @click.stop="delClassObj = { ...item, status: true }">
                  解散班级
                </p>
              </div>
            </div>
            <div class="clTeach flex">
              <div class="line1">{{ item.classesAdmin }}</div>
              <span class="iconfont denglurenxiang"></span>
              <p class="clPerson flex-center">
                <span class="clNum">{{ item.studentCnt }}</span> 人
              </p>
            </div>
            <div class="invite">
              学生邀请码：<span>{{ item.invitationCode }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <template v-if="!addClsList.length && isLoaded">
      <div class="flex-center flex-v space" @click="openAddClass" v-if="isPage">
        <span class="iconfont tianjia"></span>
        加入班级
      </div>
      <Empty v-else/>
    </template>
    <Create ref="classRef" @toRefresh="loadClassList" />

    <Dialog title="解散班级" :modal="true" width="900px" :visible.sync="delClassObj.status">
      <div class="vfWrap flex-v flex-center">
        <p class="diTxt">
          请在下方输入框中输入“<span style="color: #ff5c5c">解散班级</span>”<br />即可完成解散“<span style="color: #FB7C33">{{
            delClassObj.gradeTxt
          }}</span>”的操作，解散班级后，将不可找回班级数据，请谨慎操作！
        </p>
        <Input v-model="delClassObj.delTxt" autocomplete="off" placeholder="请输入..." style="width: 320px"></Input>
        <div class="dialog-footer">
          <div class="btn cancel flex-center" @click="delClassObj = {}">
            取 消
          </div>
          <div class="btn sure flex-center" @click="delClasses">确 认</div>
        </div>
      </div>
    </Dialog>

    <Dialog title="加入班级" :modal="true" width="900px" :visible.sync="addStatus">
      <div class="vfWrap flex-v flex-center">
        <template v-if="isAudit">
          <img :src="`https://llss-file.langsounds.com/app/${failInfo.id
            ? 'cb6a17a7198cb887bccb7b57a9664022'
            : '41ab1425174eb7336538cec75169b66c'
            }.png`" />
          <h4 class="adtxt" :class="failInfo.id && 'fail'">
            {{ failInfo.id ? "已拒绝" : "审核中" }}
          </h4>
          <p class="adtip" style="margin-bottom: 0" v-if="failInfo.id">
            您的入班申请已被
            <span>{{ failInfo.handleName }}</span>
            拒绝，<br />请与老师联系后，重新提交申请。
          </p>
          <p class="adtip" v-else>
            您的入班申请已提交，<br />请耐心等待班级管理员的审核
          </p>
          <div class="dialog-footer" v-if="failInfo.id">
            <div class="btn sure flex-center" @click="onReset">重新提交</div>
          </div>
        </template>
        <template v-else>
          <Form :model="form" :rules="rules" ref="ruleForm" label-position="right" label-width="110px">
            <FormItem label="班级邀请码" prop="invitationCode">
              <Input v-model="form.invitationCode" placeholder="请输入邀请码" style="width: 320px" clearable></Input>
            </FormItem>
            <FormItem label="老师姓名" prop="name">
              <Input v-model="form.name" placeholder=" 请输入您的真实姓名用于班级审核" style="width: 320px" :maxlength="10"
                clearable></Input>
            </FormItem>
            <p style="margin-left: 110px">您的真实姓名只对班级老师、学生可见</p>
          </Form>
          <div class="dialog-footer">
            <div class="btn cancel flex-center" @click="addStatus = false">
              取 消
            </div>
            <div class="btn sure flex-center" @click="joinClass">完成</div>
          </div>
        </template>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { Dialog, Input, Button, Form, FormItem } from "element-ui";
import Create from "./create.vue";
import util from "libs/util";
import Empty from "business/Empty";

export default {
  props: {
    isPage: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Create,
    Dialog,
    Input,
    Form,
    Empty,
    FormItem,
    ElButton: Button,
  },
  created() {
    this.loadClassList();
  },
  data() {
    return {
      form: {},
      delClassObj: {},
      addStatus: false,
      isAudit: false,
      failInfo: {},
      myClsList: [], //我创建的
      addClsList: [], //我加入的
      authStatus: {
        AUTH_WAITING: "未认证",
        AUTH_YES: "已认证",
        AUTH_NO: "未通过",
      },
      rules: {
        invitationCode: [
          { required: true, message: "请输入邀请码", trigger: "change" },
        ],
        name: [
          {
            required: true,
            message: " 请输入您的真实姓名用于班级审核",
            trigger: "change",
          },
        ],
      },
      isLoaded: false,
    };
  },
  methods: {
    openAddClass() {
      this.form = {};
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      this.isAudit = false;
      this.failInfo = {};
      this.addStatus = true;
    },
    onReset() {
      this.addStatus = false;
      this.loadClassList();
    },
    async changeStatus(item) {
      const { classesAuditStatus, classesApplyRecordId } = item;
      if (classesAuditStatus == 2) return this.$emit('onDetail', item.id);
      if (classesAuditStatus == 3) this.failInfo = item;
      this.isAudit = true;
      this.addStatus = true;
      await this.$post("/classes/readStatusClassesApply.json", {
        classesApplyRecordId,
      });
    },
    async joinClass() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await this.$post(
              "/classes/joinTheClasses.json",
              this.form
            );
            // 1不需要审核  2需要审核
            if (res.data == 2) {
              this.isAudit = true;
            } else if (res.data == 1) {
              this.addStatus = false;
              this.$toast("加入班级成功");
            } else {
              this.$toast(res.message);
            }
            if (res.data) this.loadClassList();
          } catch (error) {}
        }
      });
    },
    async loadClassList() {
      this.isLoaded = false;
      try {
        const res = await this.$post("/home/classesList.json", {});
        const result = {
          my: [],
          add: [],
        };
        let list = res.data || [];
        if (!this.isPage) list = list.filter(item => item.classesAuditStatus === 2)
        list.forEach((item) => {
          item.gradeTxt = (item.name?.includes('年级') ? '' : util.gradeNumToText(item.grade)) + item.name;
          item.authStatusTxt = {
            AUTH_WAITING: "未认证",
            AUTH_YES: "已认证",
            AUTH_NO: "未通过",
          }[item.authStatus];
          item.handleName =
            item.handleName + (item.handleName?.includes("老师") ? "" : "老师");
          item.classesAdmin =
            item.classesAdmin + (item.classesAdmin?.includes("老师") ? "" : "老师");
          item.classesAuditStatusTxt = ["待审核", "通过", "拒绝"][
            +item.classesAuditStatus - 1
          ];
          item.isCreator ? result.my.push(item) : result.add.push(item);
        });
        // isJoin  是否班级管理员 0=是 1=否
        this.myClsList = [...result.my];
        this.addClsList = [...result.add];
        console.log("-----------", this.addClsList);
        this.isLoaded = true;
      } catch (error) {
        console.log("-----------", error);
        this.myClsList = [];
        this.addClsList = [];
        this.isLoaded = true;
      }
    },
    async delClasses() {
      if (this.delClassObj.delTxt !== "解散班级")
        return this.$toast("请正确输入“解散班级”");
      try {
        await this.$post("/classes/delClasses.json", {
          classesId: this.delClassObj.id,
        });
        this.loadClassList();
        this.$toast("班级解散成功");
        this.delClassObj = {};
      } catch (error) {
        this.$toast("解散失败，请核验信息后再试");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.space {
  width: 520px;
  height: 200px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 16px 19px -5px rgba(0, 0, 0, 0.06),
    inset 0px 1px 4px 1px #ffffff;
  border-radius: 10px;
  border: 1px solid #ffffff;
  backdrop-filter: blur(4px);
  font-size: 24px;
  color: #FB7C33;
  font-weight: bold;
  cursor: pointer;

  .iconfont {
    font-size: 44px;
    margin-bottom: 20px;
  }
}

.cmTitle {
  padding-top: 40px;
  padding-bottom: 24px;

  h4 {
    font-size: 24px;
    font-weight: bold;

    span {
      font-size: 16px;
      color: #666666;
      margin-left: 30px;
      font-weight: normal;
    }
  }

}

ul {
  flex-wrap: wrap;
  width: 100%;

  li {
    width: 32%;
    box-shadow: 0px 16px 19px -5px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    margin-right: 2%;

    &:nth-child(3n + 3) {
      margin-right: 0;
    }

    &:nth-child(n + 4) {
      margin-top: 40px;
    }

    .clHead {
      height: 40px;
      border-radius: 10px 10px 0px 0px;
      background: rgba(255, 255, 255, 0.5);
      // box-shadow: 0px 16px 19px -5px rgba(0,0,0,0.06), inset 0px 1px 4px 1px #FFFFFF;
      border: 1px solid #ffffff;
      backdrop-filter: blur(4px);
      padding: 0 20px;
    }



    .clInfos {
      padding: 24px 32px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 0px 0px 10px 10px;



      .clRight {
        position: relative;
        max-width: 75%;

        .grade {
          font-size: 24px;
          color: #333333;
          font-weight: bold;
        }

        .clTeach {
          font-size: 20px;
          color: #333333;
          font-weight: bold;
          align-items: center;
          padding-top: 8px;
          padding-bottom: 12px;

          .line1 {
            max-width: 60%;
          }

          .iconfont {
            font-weight: normal;
            color: #ccc;
            margin-left: 26px;
            margin-right: 10px;
            font-size: 18px;
          }
        }

        .clPerson {
          font-size: 12px;
          color: #666;
          align-items: baseline;

          span {
            font-size: 24px;
            color: #333;
            font-weight: bold;
            padding-right: 4px;
          }
        }

        .invite {
          font-size: 16px;
          color: #666666;

          span {
            font-size: 24px;
            color: #FB7C33;
            font-weight: bold;
          }
        }
      }
    }
  }
}

.diTxt {
  width: 386px;
  text-align: center;
  font-size: 16px;
  color: #333333;
  margin-bottom: 32px;
  font-weight: bold;
  line-height: 24px;
}

.adtxt {
  margin: 8px 0;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}

.alignCenter {
  text-align: center;
}

.adtip {
  // width: 154px;
  text-align: center;
  font-size: 12px;
  color: #999999;
  margin-bottom: 60px;

  span {
    font-weight: bold;
    color: #333333;
  }
}
</style>
